<template>
  <div>
    <!-- z-index 300 to cater for safari bug -->
    <v-select
      label="Grade Scale"
      v-model="model.gradeScale"
      :items="scales"
      @input="update"
      clearable
      :color="color"
      :dark="dark"
    />

    <v-slider v-if="model.gradeScale === 'Percentage'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''}`"
      :min="0" :max="100"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-slider v-if="['4-point GPA', 'Liberian 4-point GPA', 'Nigerian 4-point GPA'].indexOf(model.gradeScale) >= 0"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''}`"
      :min="0" :max="4" :step="0.01"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-slider v-if="['5-point GPA', 'Ugandan 5-point GPA', 'Nigerian 5-point GPA'].indexOf(model.gradeScale) >= 0"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''}`"
      :min="0" :max="5" :step="0.01"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-slider v-if="model.gradeScale === '6-point GPA'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''}`"
      :min="0" :max="6" :step="0.01"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-slider v-if="model.gradeScale === '7-point GPA'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''}`"
      :min="0" :max="7" :step="0.01"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-slider v-if="model.gradeScale === 'International Baccalaureate Point Grade'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''}`"
      :min="0" :max="7" :step="1"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-select v-if="['Botswana Class Grade', 'British Class Grade', 'Kenyan Class Grade', 'Zimbabwe Class Grade'].indexOf(model.gradeScale) >= 0"
      v-model="model.gradeValue"
      label="Class"
      :items="[
        { text: 'First Class', value: '1' },
        { text: 'Upper Second', value: '2.1' },
        { text: 'Lower Second Class', value: '2.2' },
        { text: 'Third Class', value: '3' },
        { text: 'Fail', value: 'F' },
      ]"
      @input="update"
      :color="color"
    />
    <v-slider v-if="model.gradeScale === 'Benin 20-point GPA'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''}`"
      :min="0" :max="20" :step="0.01"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-slider v-if="model.gradeScale === 'Ugandan UACE Points Grade'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || 0} points`"
      :min="0" :max="20" :step="1"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-slider v-if="model.gradeScale === 'Botswana GCSE Points Grade'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''} points`"
      :min="0" :max="48" :step="1"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'Botswana GCSE Letter Grade'"
      v-model="model.gradeValue"
      label="Class"
      :items="['A*', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'U']"
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'Cambridge Number Grade'"
      v-model="model.gradeValue"
      label="Class"
      :items="['1', '2', '3', '4', 'U']"
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'Cameroon Letter Grade'"
      v-model="model.gradeValue"
      label="Grade"
      :items="['A', 'B+', 'B', 'C+', 'C', 'D+', 'D', 'F']"
      @input="update"
      :color="color"
    />
    <v-slider v-if="model.gradeScale === 'Cameroon Point Grade'"
      v-model="model.gradeValue"
      :label="`Grade: ${model.gradeValue || ''} points`"
      :min="0" :max="20" :step="0.1"
      thumb-label
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'KCSE Letter Grade'"
      v-model="model.gradeValue"
      label="Grade"
      :items="['A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F']"
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'Kenyan Letter Grade'"
      v-model="model.gradeValue"
      label="Grade"
      :items="['A', 'B', 'C', 'D', 'F']"
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'WAEC Grading'"
      v-model="model.gradeValue"
      label="Grade"
      :items="['A1', 'B2', 'B3', 'C4', 'C5', 'C6', 'D7', 'E8', 'F9']"
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'Zambian Points Grading'"
      v-model="model.gradeValue"
      label="Class"
      :items="['Distinction', 'Merit', 'Credit', 'Pass', 'Fail']"
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'A-Level Letter Grade'"
      v-model="model.gradeValue"
      label="Letter Grade"
      :items="['A', 'B', 'C', 'D', 'E', 'O', 'F']"
      @input="update"
      :color="color"
    />
    <v-select v-if="model.gradeScale === 'O-Level Letter Grade'"
      v-model="model.gradeValue"
      label="Letter Grade"
      :items="['A', 'B', 'C', 'D', 'E', 'U']"
      @input="update"
      :color="color"
    />
  </div>
</template>

<script>
// Helpers
import { mapGetter } from 'vuex'

// Data
import gradeScales from '@/data/grade_scales'

// Vue Component
export default {
  props: {
    // Grade information
    value: Object,
    scales: {
      type: Array,
      default: () => gradeScales
    },
    // Styling
    color: {
      type: String,
      default: () => 'deep-orange'
    },
    dark: Boolean
  },
  data() {
    return {
      // Model
      model: {
        gradeScale: this.value.gradeScale,
        gradeValue: this.value.gradeValue
      }
    }
  },
  methods: {
    update() {
      if (!this.model.gradeScale) {
        this.model.gradeValue = null
      }

      this.$emit('input', this.model)
    }
  }
}
</script>
